import React from 'react'
import './members.css';

function Members() {
  return (
    <div className='mbody'>
      <div class="mheader">
   <img alt="Logo" height="50" src="https://cdn-icons-png.flaticon.com/128/346/346195.png" width="50"/>
   <h1>
    Meet Expert Members
   </h1>
  </div>
  <div class="members">
   <div class="member">
    <img alt="Mike Brown holding fresh vegetables in a farm" height="300" src="https://img.freepik.com/premium-photo/businesswoman-office-sitting-with-laptop-looking-camera_360066-17105.jpg" width="250"/>
    <div class="member-info">
     <h3>
      Mike Brown
     </h3>
     <p>
      Expert 
     </p>
     
    </div>
   </div>
   <div class="member">
    <img alt="Alees Hardson working in a greenhouse" height="300" src="https://t4.ftcdn.net/jpg/04/43/76/95/360_F_443769563_XLcCTl78ajnm9VS6kEWFIEMHRMUdm26Z.jpg" width="250"/>
    <div class="member-info">
     <h3>
      Alees Hardson
     </h3>
     <p>
      Expert 
     </p>
     
    </div>
   </div>
   <div class="member">
    <img alt="Polard Albert standing in a field" height="300" src="https://media.istockphoto.com/id/1369199360/photo/portrait-of-a-handsome-young-businessman-working-in-office.jpg?s=612x612&w=0&k=20&c=ujyGdu8jKI2UB5515XZA33Tt4DBhDU19dKSTUTMZvrg=" width="250"/>
    <div class="member-info">
     <h3>
      Polard Albert
     </h3>
     <p>
      Expert 
     </p>
     
    </div>
   </div>
   <div class="member">
    <img alt="Jassica Andrew holding grapes in a vineyard" height="300" src="https://img.freepik.com/free-photo/brunette-businesswoman-posing_23-2148142728.jpg" width="250"/>
    <div class="member-info">
     <h3>
      Jassica Andrew
     </h3>
     <p>
      Expert 
     </p>
     
    </div>
   </div>
  </div>
    </div>
  )
}

export default Members
